import { render } from "./NoPageFoundView.vue?vue&type=template&id=3924d34a&scoped=true"
import script from "./NoPageFoundView.vue?vue&type=script&lang=js"
export * from "./NoPageFoundView.vue?vue&type=script&lang=js"

import "./NoPageFoundView.vue?vue&type=style&index=0&id=3924d34a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3924d34a"]])

export default __exports__